import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SvgPlayFilled } from '../../../../icons';
import { routes } from '../../../../routes/route-utils';
import { localizedRelativeTime } from '../../../../utils/ats-details-utils';
import { getAuth } from '../../../../utils/auth-utils';
import { appendSequenceNumbers } from '../../utils';
import { CallToAction } from '../call-to-action-button';
import { ContinueWatchingButton } from '../continue-watching-button';
import { isLimitedToHomeNetwork } from '../utils';
import { ExpiredCallToAction } from './expired-call-to-action';
import { NotAvailableCallToAction } from './not-available-call-to-action';
import { ProgramCallToActionProps } from './program-call-to-action';
import { ProgramGetAccessCallToAction } from './program-get-access';
import { ThirdPartyCatchupCallToAction } from './third-party-catchup-call-to-action';

export function PastProgramCallToAction({ focusedAsset, source }: ProgramCallToActionProps) {
  const { t } = useTranslation();
  const now = moment();

  const thirdPartyTreshold = moment(source.endTime).add(15, 'minutes');

  if (now.isAfter(thirdPartyTreshold) && source.relatedSource && source.relatedSource.type === 'thirdparty') {
    return <ThirdPartyCatchupCallToAction asset={focusedAsset} source={source.relatedSource} />;
  }

  if (!source.isSubscribed) {
    return <ProgramGetAccessCallToAction source={source} />;
  }

  const auth = getAuth();

  if (isLimitedToHomeNetwork(source) && !auth.isHome) {
    return <NotAvailableCallToAction source={source} />;
  }

  const expiration = moment(source.expiresAt);

  if (now.isAfter(expiration)) {
    return <ExpiredCallToAction source={source} />;
  }

  if (source.bookmark !== undefined) {
    return <ContinueWatchingButton bookmark={source.bookmark} source={source} focusedAsset={focusedAsset} />;
  }

  return (
    <CallToAction
      text={{
        primary: appendSequenceNumbers(t('details:watch-now'), focusedAsset),
        secondary: localizedRelativeTime(source.startTime, 'airtime'),
      }}
      image={{
        src: source.image,
        alt: source.name,
      }}
      icon={<SvgPlayFilled />}
      to={routes.play({ platformTitleId: source.platformTitleId, providerIdentifier: source.providerIdentifier })}
    />
  );
}
